<phx-drag-handle *ngIf="!isViewMode"></phx-drag-handle>
<div class="phx-drag-item-inline-content">
  <ng-content></ng-content>
</div>
<div class="phx-drag-item-inline-actions">
  <ng-content select="[phx-drag-item-inline-action]"></ng-content>
</div>

<ng-template #dragItemPlacehoder>
  <div class="phx-drag-item-inline-placeholder" [ngStyle]="placeholderStyles" [ngClass]="phxPlaceholderClass">
    <div class="phx-drag-item-inline-placeholder-inner"></div>
  </div>
</ng-template>